import { render, staticRenderFns } from "./cModalCarroRecipe.vue?vue&type=template&id=703cd196&scoped=true"
import script from "./cModalCarroRecipe.vue?vue&type=script&lang=js"
export * from "./cModalCarroRecipe.vue?vue&type=script&lang=js"
import style0 from "./cModalCarroRecipe.vue?vue&type=style&index=0&id=703cd196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703cd196",
  null
  
)

export default component.exports